module.exports = __webpack_public_path__ + "dist/media/Rectangle 23.ef59ac37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/Rectangle 23.png
// module id = 374
// module chunks = 0